var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBok3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4333 22.2285L22.1 26.1452H18.75L20.4333 22.2285Z",
    fill: "url(#paint0_linear_8609_64671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.8833 12.8779H30.85V11.5612C30.85 9.47786 29.1667 7.8112 27.1 7.8112H12.9333C12.2333 7.8112 11.6833 8.3612 11.6833 9.0612C11.6833 9.7612 12.2333 10.3112 12.9333 10.3112H27.1C27.7833 10.3112 28.35 10.8612 28.35 11.5612V12.8779H11.6333C10.8333 12.8779 9.73333 12.7279 8.98333 12.0279C7.93333 11.0279 7.43333 9.9612 7.5 8.84453C7.6 7.49453 8.5 6.3612 9.33333 5.7612C9.66667 5.5112 10.1833 5.39453 10.9333 5.39453H31.25C31.9333 5.39453 32.5 4.82786 32.5 4.14453C32.5 3.4612 31.9333 2.89453 31.25 2.89453H10.9333C10.1 2.89453 8.88333 2.97786 7.85 3.74453C6.18333 4.9612 5.13333 6.8112 5 8.69453C5 8.9112 5 9.14453 5 9.37786V9.42786L5.05 30.9945C5.3 35.5445 8.5 38.7279 12.85 38.7279H27.9167C32.2833 38.7279 35.8333 35.1612 35.8333 30.7779V18.3612C35.8333 15.8612 34.9833 12.8779 30.8833 12.8779ZM25.9167 31.8612C25.7667 31.9445 25.5833 31.9779 25.4333 31.9779C24.9333 31.9779 24.4833 31.6945 24.2833 31.2112L23.1667 28.6445H17.6833L16.5833 31.2112C16.3 31.8445 15.5667 32.1445 14.9333 31.8612C14.3 31.5945 14 30.8612 14.2833 30.2279L15.7 26.9279C15.7 26.9279 15.7167 26.8945 15.7167 26.8612L18.2833 20.8612C18.65 20.0112 19.4833 19.4779 20.4333 19.4779C21.3833 19.4779 22.2 20.0112 22.5667 20.8612L25.1333 26.8612C25.1333 26.8612 25.15 26.9112 25.15 26.9279L26.5833 30.2279C26.85 30.8612 26.55 31.5945 25.9167 31.8612Z",
    fill: "url(#paint1_linear_8609_64671)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8609_64671",
    x1: 18.75,
    y1: 24.1868,
    x2: 22.1,
    y2: 24.1868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698ADE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8609_64671",
    x1: 5,
    y1: 20.8112,
    x2: 35.8333,
    y2: 20.8112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698ADE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBok3);
export default __webpack_public_path__ + "static/media/bok3.7d795ad3ec6bc12db00cc3a8a3e3f125.svg";
export { ForwardRef as ReactComponent };